import { mutate } from 'swr';
import axios from 'axios';
import { SERVICES } from '@shared/constants/apiConfig';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { getError } from '@shared/utils/helpers';
import { ITitileFees } from './TitleFees';

const BASE_URL = `${SERVICES.LENDER}/titlefees`;

export const requestAddNewTitleFee = (data: ITitileFees) => {
  return mutate(BASE_URL, async () => {
    try {
      await axios.post(`${BASE_URL}`, data);
      Notistack.successMessage('Title Fee Added Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateTitleFee = (id: string, data: ITitileFees) => {
  return mutate(BASE_URL, async () => {
    try {
      await axios.put(`${BASE_URL}/${id}`, { ...data, id });
      Notistack.successMessage('Title Fee Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteTitleFee = (id: string) => {
  return mutate(BASE_URL, async () => {
    try {
      await axios.delete(`${BASE_URL}/${id}`);
      Notistack.successMessage('Title Fee deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};